import { getAuthenticatedUser, User } from '@libs/focus-frontend-services/src/AuthenticationService';

export class UserMismatchError extends Error {
  name = 'UserMismatchError';
}

export class UnauthorizedError extends Error {
  name = 'UnauthorizedError';
}

export class NotFoundError extends Error {
  name = 'NotFoundError';
}

interface JSONAction {
  module: string;
  fn: string;
  params?: any[];
}

export class JSONActionsError extends Error {
  name = 'JSONActions';
  actions;

  constructor(actions: JSONAction[]) {
    super();
    this.actions = actions;
  }
}

export class BadRequestError extends Error {
  name = 'BadRequestError';
  message;

  constructor(message: string) {
    super(message);
    this.message = message;
  }
}

export class InternalServerError extends Error {
  name = 'InternalServerError';
}

export class RequestTookTooLongError extends Error {
  name = 'RequestTookTooLongError';
}

export class LoadError extends Error {
  name = 'LoadError';

  constructor(file: string) {
    super(`Failed to load ${file}`);
  }
}

export const assertResponse = async (response: Response) => {
  const userIntId = response.headers.get('X-TLUID');
  if (userIntId && parseInt(userIntId) !== getAuthenticatedUser(User.EmployeeId)) {
    throw new UserMismatchError();
  }

  if (response.status === 401) {
    throw new UnauthorizedError();
  }

  if (response.status === 404) {
    throw new NotFoundError();
  }

  if (response.status === 252 || response.status === 254) {
    const JSONActions = await response.json();
    throw new JSONActionsError('actions' in JSONActions ? JSONActions.actions : [JSONActions]);
  }

  if (response.status === 253) {
    const { message } = await response.json();
    throw new BadRequestError(message);
  }

  if (response.status >= 500 && response.status < 600) {
    throw new InternalServerError();
  }

  if (response.ok) {
    return;
  }

  throw new Error(`Unknown HTTP error with status ${response.status}`);
};
